import { randomNumber } from '../../../../utilities'
import { ImagingUltrasoundConstants } from './imagingUltrasound.constants'
import { IImagingUltrasoundActions, IImagingUltrasoundState } from './ImagingUltrasound.types'

export const initialImagingUltrasoundState: IImagingUltrasoundState = {
  assessedBy: null,
  procedureComplications: [],
  authorization: null,
  comments: '',
  response: null,
  responsePNNV: null,
  addToTimeline: false,
  updateInputRows: false,
  key: randomNumber().toString(),
  date: '',
  time: '',
  imageType: null,
  type: 'Imaging/Ultrasound',
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  location: null,
  findings: null,
  pta: false,
  isEkgImport: null,
  nemsisCode: null,
}

export function imagingUltrasoundReducer(
  state: IImagingUltrasoundState = initialImagingUltrasoundState,
  action: IImagingUltrasoundActions
): IImagingUltrasoundState {
  switch (action.type) {
    case ImagingUltrasoundConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case ImagingUltrasoundConstants.SET_DATE:
      return { ...state, date: action.date }
    case ImagingUltrasoundConstants.SET_TIME:
      return { ...state, time: action.time }
    case ImagingUltrasoundConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case ImagingUltrasoundConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case ImagingUltrasoundConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case ImagingUltrasoundConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case ImagingUltrasoundConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case ImagingUltrasoundConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case ImagingUltrasoundConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case ImagingUltrasoundConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case ImagingUltrasoundConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case ImagingUltrasoundConstants.SET_STATE:
      return { ...action.imagingUltrasoundState, updateInputRows: true }
    case ImagingUltrasoundConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case ImagingUltrasoundConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case ImagingUltrasoundConstants.SET_LOCATION:
      return { ...state, location: action.location }
    case ImagingUltrasoundConstants.SET_FINDINGS:
      return { ...state, findings: action.findings }
    case ImagingUltrasoundConstants.SET_TYPE:
      return { ...state, imageType: action.imageType }
    case ImagingUltrasoundConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case ImagingUltrasoundConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case ImagingUltrasoundConstants.RESET_STATE:
      return {
        key: randomNumber().toString(),
        date: '',
        time: '',
        pta: false,
        assessedBy: null,
        response: null,
        responsePNNV: null,
        procedureComplications: [],
        authorization: null,
        comments: '',
        addToTimeline: false,
        updateInputRows: true,
        imageType: null,
        type: 'Imaging/Ultrasound',
        rolePerforming: null,
        rolePerformingPNNV: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        location: null,
        findings: null,
        isEkgImport: null,
        nemsisCode: null,
      }
    default:
      return state
  }
}
